

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32","height":"32"}, rest), [h('path', {"fill":"#222228","fill-rule":"evenodd","d":"M25 16a9 9 0 11-18.001-.001A9 9 0 0125 16zm-9.921-2.865h1.842a.45.45 0 00.45-.45v-1.842a.45.45 0 00-.45-.449H15.08a.45.45 0 00-.45.45v1.842a.45.45 0 00.45.449zm0 8.47h1.842c.248 0 .45-.2.45-.448v-5.954a.45.45 0 00-.45-.449H15.08a.45.45 0 00-.45.45v5.953a.45.45 0 00.45.449zM27 16c0 6.074-4.926 11-11 11S5 22.074 5 16 9.926 5 16 5s11 4.926 11 11z"}, [])]);
};

        